export default "__VITE_ASSET__YR47ObUr__"